import React, { FC } from 'react';
import { PopupProvider as CommonPopupProvider } from '@sunbit-dev/purchase-common/src/components/popupProvider/PopupProvider';
import { activePopupBackdropCss } from './styles';

export const PopupProvider: FC = ({ children }) => <CommonPopupProvider {...{ activePopupBackdropCss }}>{children}</CommonPopupProvider>;
